import actions from './actions';
import getters from './getters';
import mutations from './mutations';

/**
 * Register module state.
 *
 * @returns {object} Register state.
 */
const state = () => ({
    // state
    modalOpen: false,
    isLoading: false,
    isPreviousStepLocked: false,
    // steps
    step: undefined,
    stepIndex: 0,
    stepsCount: 0,
    // data
    action: undefined,
    show: undefined,
    plan: undefined,
    trialEnabled: undefined,
    promo: undefined,
    trialSkippedByPromo: false,
    couponDiscounts: {},
    // errors
    cardError: null,
});

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
